import {StripeApi, StripeAuthorize, StripePaymentDashboard} from "@betrue/shared/interfaces";
import {useState} from "react";
import {useResult} from "./results";
import {gql, useLazyQuery, useMutation} from "@apollo/client";

const STRIPE_AUTHORIZE = gql`
  query authorize {
    authorize {
      authorizeUrl
    }
  }
`

const STRIPE_DASHBOARD = gql`
  query dashboard($id: String!) {
    dashboard(id:$id) {
      loginLink
      id
      balance
      pending
    }
  }
`
const STRIPE_PAYOUT = gql`
  mutation payout($id: String!) {
    payout(id:$id) {
      loginLink
      id
      balance
      pending
    }
  }
`

export const useStripe = <T extends StripeAuthorize | StripePaymentDashboard>(): [T, StripeApi] => {
  const [result, setResult] = useState<T>();
  const authorize = useResult(useLazyQuery(STRIPE_AUTHORIZE, {fetchPolicy: 'network-only'}), setResult)
  const paymentDashboard = useResult(useLazyQuery(STRIPE_DASHBOARD, {fetchPolicy: 'network-only'}), setResult)
  const payout = useResult(useMutation(STRIPE_PAYOUT), setResult)


  return [
    result, {
      authorize() {
        authorize()
      },
      payout(id: string) {
        payout({
          variables: {
            id: id
          }
        })
      },
      dashboard(id: string) {
        paymentDashboard({
          variables: {
            id: id
          }
        })
      }
    }]
}
